import * as types from '@/store/mutation-types'

const state = {
    tokn          : '',
    userInfo      : '',
    userNo        : '',
    userNm        : '',
    children      : '',
    selectedChild : '',
    roleList      : [],
}

const getters = {
    tokn         : state => state.tokn,
    userInfo     : state => state.userInfo,
    userNo       : state => state.userNo,
    userNm       : state => state.userNm,
    children     : state => state.children,
    selectedChild: state => state.selectedChild,
    roleList     : state => state.roleList,
    isVacaAprv   : state => state.roleList.some(role => role.roleCd === 'VACA_APRV'),
}

const mutations = {
    [types.TOKN](state, value) {
        state.tokn = value;
    },
    [types.USER_INFO](state, value) {
        state.userInfo = value;
    },
    [types.USER_NO](state, value) {
        state.userNo = value;
    },
    [types.USER_NM](state, value) {
        state.userNm = value;
    },
    [types.CHILDREN](state, value) {
        state.children = value;
    },
    [types.SELECTED_CHILD](state, value) {
        state.selectedChild = value;
    },
    [types.ROLE_LIST](state, value) {
        state.roleList = value || [];
    },
}

export default {
    state,
    getters,
    mutations
}
